import React from "react";

const MOUNTAIN =
  "https://images.unsplash.com/photo-1594748526885-d184fe0259a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjYXVjYXN1cyUyMG1vdW50YWlucyUyMG1vb2R5fGVufDB8fHx8MTc4MTc4MTgzNHww&ixlib=rb-4.1.0&q=85";
const LEATHER =
  "https://images.unsplash.com/photo-1571829604981-ea159f94e5ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx0cmFkaXRpb25hbCUyMHdvb2wlMjBsZWF0aGVyJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODE3ODE4MzR8MA&ixlib=rb-4.1.0&q=85";

export const About = ({ t }) => {
  return (
    <section
      id="heritage"
      data-testid="about-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32 bg-[#1C1A18]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Left: text block */}
        <div className="lg:col-span-6 flex flex-col justify-center">
          <p className="overline mb-6">{t.about.overline}</p>
          <h2 className="font-serif font-light text-[#F3EFE9] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-10">
            {t.about.title_l1}
            <br />
            <span className="italic text-[#A67A53]">{t.about.title_l2}</span>
          </h2>
          <p className="text-[#F3EFE9]/80 text-base md:text-lg leading-relaxed mb-6 max-w-xl font-light">
            {t.about.p1}
          </p>
          <p className="text-[#9D9287] text-base md:text-lg leading-relaxed max-w-xl font-light">
            {t.about.p2}
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl border-t border-[#3A342E] pt-8">
            <div>
              <p className="font-serif text-3xl md:text-4xl text-[#F3EFE9] font-light">{t.about.stat1_value}</p>
              <p className="overline mt-2">{t.about.stat1_label}</p>
            </div>
            <div>
              <p className="font-serif text-3xl md:text-4xl text-[#F3EFE9] font-light">{t.about.stat2_value}</p>
              <p className="overline mt-2">{t.about.stat2_label}</p>
            </div>
            <div>
              <p className="font-serif text-3xl md:text-4xl text-[#F3EFE9] font-light">{t.about.stat3_value}</p>
              <p className="overline mt-2">{t.about.stat3_label}</p>
            </div>
          </div>
        </div>

        {/* Right: overlapping images */}
        <div className="lg:col-span-6 relative min-h-[480px] md:min-h-[640px]">
          <div className="editorial-img absolute top-0 left-0 w-[78%] h-[70%] z-10">
            <img src={MOUNTAIN} alt="Caucasus mountain landscape" loading="lazy" />
          </div>
          <div className="editorial-img absolute bottom-0 right-0 w-[55%] h-[55%] z-20 border-4 border-[#1C1A18]">
            <img src={LEATHER} alt="Brown leather texture" loading="lazy" />
          </div>
          <p className="absolute top-1/2 right-4 transform -translate-y-1/2 z-30 font-serif italic text-[#A67A53]/60 text-7xl md:text-8xl select-none pointer-events-none">
            к.
          </p>
        </div>
      </div>
    </section>
  );
};
